import Image from 'next/image';

import { CDN_BASE_URL } from '@/lib/constants/cdn';
import { MessageSkeletonProps } from '@/types';

export function MessageSkeleton() {
  return (
    <div className='w-full flex-1'>
      <div
        className='relative w-full rounded-b-lg border border-purple-100 bg-white p-2.5 shadow-md dark:border-purple-800/50 dark:bg-gray-800/50 dark:shadow-gray-900/30 sm:p-3.5 md:p-4'
        data-testid='message-skeleton'
      >
        <div className='flex items-start space-x-3'>
          <div className='flex h-[50px] w-[50px] flex-shrink-0 items-center justify-center rounded-lg'>
            <div
              className='relative h-[50px] w-[50px] animate-spin'
              style={{ animationDuration: '2s' }}
            >
              <Image
                src={`${CDN_BASE_URL}/JAQLNLogo.png`}
                alt='Jaqln Logo'
                fill
                priority
                sizes='50px'
                style={{ objectFit: 'cover' }}
              />
            </div>
          </div>
          <div className='min-w-0 flex-1'>
            <div className='flex h-[50px] items-center space-x-1.5'>
              <div className='h-1.5 w-1.5 animate-bounce rounded-full bg-purple-600 dark:bg-purple-500'></div>
              <div
                className='h-1.5 w-1.5 animate-bounce rounded-full bg-purple-600 dark:bg-purple-500'
                style={{ animationDelay: '0.2s' }}
              ></div>
              <div
                className='h-1.5 w-1.5 animate-bounce rounded-full bg-purple-600 dark:bg-purple-500'
                style={{ animationDelay: '0.4s' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ChatGroupSkeleton({ count = 3 }: MessageSkeletonProps) {
  return (
    <div className='space-y-2' data-testid='chat-group-skeleton'>
      <div className='px-3 py-2'>
        <div
          className='h-4 w-24 animate-pulse rounded bg-gray-200 text-xs dark:bg-gray-700'
          data-testid='group-title-skeleton'
        ></div>
      </div>
      <div className='space-y-[1px]' data-testid='chat-items-skeleton'>
        {Array.from({ length: count }).map((_, i) => (
          <ChatItemSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

function ChatItemSkeleton() {
  return (
    <div
      className='relative flex w-full items-center space-x-3 border-b border-gray-200 px-3 py-2 shadow-sm shadow-purple-200 transition-colors hover:bg-gray-50 dark:border-gray-700/50 dark:shadow-none dark:hover:bg-gray-800/60'
      data-testid='chat-item-skeleton'
    >
      <div className='flex-shrink-0'>
        <div className='h-5 w-5 animate-pulse rounded bg-gray-200 dark:bg-gray-700'></div>
      </div>
      <div className='flex-1 space-y-2 pr-14'>
        <div className='h-4 w-[85%] animate-pulse rounded bg-gray-200 dark:bg-gray-700'></div>
        <div className='h-3 w-[60%] animate-pulse rounded bg-gray-200 dark:bg-gray-700'></div>
      </div>
      <div className='absolute right-2 flex items-center space-x-1 px-0'>
        <div className='h-6 w-6 animate-pulse rounded bg-gray-200 dark:bg-gray-700'></div>
        <div className='h-6 w-6 animate-pulse rounded bg-gray-200 dark:bg-gray-700'></div>
      </div>
    </div>
  );
}
